import { useTranslation } from 'react-i18next'
import { PortfolioIcon } from '@/components/ui/PortfolioIcon'

export const Contact = () => {
  const { t } = useTranslation()
  const href = `mailto:me@marcosaquino.com?subject=${encodeURIComponent(t('portfolio.contact.subject'))}&body=${encodeURIComponent(t('portfolio.contact.body'))}`
  return (
    <section id="contact" className="contact-section section-pad">
      <div className="shell contact-grid">
        <div>
          <p className="eyebrow">{t('portfolio.contact.eyebrow')}</p>
          <h2>{t('portfolio.contact.title')}</h2>
          <p>{t('portfolio.contact.description')}</p>
          <small>{t('portfolio.contact.note')}</small>
        </div>
        <div className="contact-actions">
          <a className="button primary" href={href}>
            {t('portfolio.contact.cta')}
            <PortfolioIcon name="arrow" />
          </a>
          <a href="mailto:me@marcosaquino.com" className="contact-email">
            me@marcosaquino.com
          </a>
        </div>
      </div>
    </section>
  )
}
